import React from "react";
import { Box, Typography, Button, Link } from "@mui/material";
import TelegramIcon from "@mui/icons-material/Telegram";
import EmailIcon from "@mui/icons-material/Email";
import theme from "../../theme/Theme";

const ContactUs = () => {
  return (
    <Box sx={styles.container}>
      <Box sx={styles.pageBgImage} />
      <Box sx={styles.wrapper}>
        <Typography variant="h5" sx={styles.contactHeading}>
          Contact Us
        </Typography>
        <Typography variant="h4" sx={styles.header}>
          Launch Your Own Draw and Start Earning!
        </Typography>
        <Typography variant="body1" sx={styles.subText}>
          Have an audience or a community? <br />
          You can <b>create your own draw on SWSSDraw.io</b> and earn{" "}
          <b>up to 10–20% instantly from every ticket sold</b>, plus{" "}
          <b>multi-level referral commissions</b> — even if users purchase
          without using a referral link.
        </Typography>
        <Typography variant="body1" sx={styles.bulletText}>
          <b>No coding or development needed</b>
          <br />
          <b>Perfect for influencers, communities, and marketers</b>
          <br />{" "}
          <b>
            Go live in less than an hour — all for a one-time setup cost of just
            $350 USDT
          </b>
        </Typography>
        <Typography variant="body1" sx={styles.subText}>
          Want to get started?
        </Typography>
        <Box sx={styles.contactButtons}>
          <Button
            variant="contained"
            startIcon={<EmailIcon />}
            sx={styles.emailButton}
            href="mailto:support@swss.io"
            target="_blank"
          >
            Email us at <b style={{ marginLeft: 5 }}>support@swss.io</b>
          </Button>
          <Button
            variant="contained"
            startIcon={<TelegramIcon />}
            sx={styles.telegramButton}
            href="https://t.me/swssdraw"
            target="_blank"
          >
            Reach out via Telegram
          </Button>
        </Box>
        <Typography variant="body2" sx={styles.footerText}>
          We're here to help you launch your draw quickly and smoothly.
        </Typography>
      </Box>
    </Box>
  );
};

export default ContactUs;

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
  },
  pageBgImage: {
    position: "absolute",
    backgroundColor: "#fcfcfe",
    backgroundImage:
      "url(\"data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M54.627 0l.83.828-1.415 1.415L51.8 0h2.827zM5.373 0l-.83.828L5.96 2.243 8.2 0H5.374zM48.97 0l3.657 3.657-1.414 1.414L46.143 0h2.828zM11.03 0L7.372 3.657 8.787 5.07 13.857 0H11.03zm32.284 0L49.8 6.485 48.384 7.9l-7.9-7.9h2.83zM16.686 0L10.2 6.485 11.616 7.9l7.9-7.9h-2.83zm20.97 0l9.315 9.314-1.414 1.414L34.828 0h2.83zM22.344 0L13.03 9.314l1.414 1.414L25.172 0h-2.83zM32 0l12.142 12.142-1.414 1.414L30 .828 17.272 13.556l-1.414-1.414L28 0h4zM.284 0l28 28-1.414 1.414L0 2.544V0h.284zM0 5.373l25.456 25.455-1.414 1.415L0 8.2V5.374zm0 5.656l22.627 22.627-1.414 1.414L0 13.86v-2.83zm0 5.656l19.8 19.8-1.415 1.413L0 19.514v-2.83zm0 5.657l16.97 16.97-1.414 1.415L0 25.172v-2.83zM0 28l14.142 14.142-1.414 1.414L0 30.828V28zm0 5.657L11.314 44.97 9.9 46.386l-9.9-9.9v-2.828zm0 5.657L8.485 47.8 7.07 49.212 0 42.143v-2.83zm0 5.657l5.657 5.657-1.414 1.415L0 47.8v-2.83zm0 5.657l2.828 2.83-1.414 1.413L0 53.456v-2.83zM54.627 60L30 35.373 5.373 60H8.2L30 38.2 51.8 60h2.827zm-5.656 0L30 41.03 11.03 60h2.828L30 43.858 46.142 60h2.83zm-5.656 0L30 46.686 16.686 60h2.83L30 49.515 40.485 60h2.83zm-5.657 0L30 52.343 22.343 60h2.83L30 55.172 34.828 60h2.83zM32 60l-2-2-2 2h4zM59.716 0l-28 28 1.414 1.414L60 2.544V0h-.284zM60 5.373L34.544 30.828l1.414 1.415L60 8.2V5.374zm0 5.656L37.373 33.656l1.414 1.414L60 13.86v-2.83zm0 5.656l-19.8 19.8 1.415 1.413L60 19.514v-2.83zm0 5.657l-16.97 16.97 1.414 1.415L60 25.172v-2.83zM60 28L45.858 42.142l1.414 1.414L60 30.828V28zm0 5.657L48.686 44.97l1.415 1.415 9.9-9.9v-2.828zm0 5.657L51.515 47.8l1.414 1.413 7.07-7.07v-2.83zm0 5.657l-5.657 5.657 1.414 1.415L60 47.8v-2.83zm0 5.657l-2.828 2.83 1.414 1.413L60 53.456v-2.83zM39.9 16.385l1.414-1.414L30 3.658 18.686 14.97l1.415 1.415 9.9-9.9 9.9 9.9zm-2.83 2.828l1.415-1.414L30 9.313 21.515 17.8l1.414 1.413 7.07-7.07 7.07 7.07zm-2.827 2.83l1.414-1.416L30 14.97l-5.657 5.657 1.414 1.415L30 17.8l4.243 4.242zm-2.83 2.827l1.415-1.414L30 20.626l-2.828 2.83 1.414 1.414L30 23.456l1.414 1.414zM56.87 59.414L58.284 58 30 29.716 1.716 58l1.414 1.414L30 32.544l26.87 26.87z' fill='%23f2f2f2' fill-opacity='0.4' fill-rule='evenodd'/%3E%3C/svg%3E\")",
    top: 0,
    left: 0,
    right: 0,
    zIndex: -1,
    width: "100vw",
    height: "180%",
  },
  wrapper: {
    my: 4,
    mx: { xs: 2, lg: 10 },
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: { xs: 2, sm: 4 },
    backgroundColor: theme.custom.white,
    boxShadow:
      "rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px",
    borderRadius: "8px",
  },
  header: {
    fontWeight: "bold",
    marginBottom: 2,
    color: theme.palette.text.secondary,
    fontSize: 20,
    textAlign: "center",
  },
  subText: {
    color: theme.palette.text.secondary,
    marginBottom: 3,
    textAlign: "center",
    fontSize: 18,
  },
  bulletText: {
    color: theme.palette.text.secondary,
    marginBottom: 4,
    textAlign: "center",
    fontSize: 18,
  },
  contactButtons: {
    display: "flex",
    flexDirection: { xs: "column", sm: "row" },
    gap: 3,
    justifyContent: "center",
    alignItems: "center",
    marginBottom: 3,
    width: "100%",
  },
  emailButton: {
    backgroundColor: "#0088cc",
    color: "#fff",
    padding: "10px 20px",
    fontSize: "16px",
    textTransform: "none",
    transition: "background-color 0.3s ease",
    width: { xs: "100%", sm: "auto" },
    "&:hover": {
      backgroundColor: "#115293",
    },
  },
  telegramButton: {
    backgroundColor: "#0088cc",
    color: "#fff",
    padding: "10px 20px",
    fontSize: "16px",
    textTransform: "none",
    transition: "background-color 0.3s ease",
    width: { xs: "100%", sm: "auto" },
    "&:hover": {
      backgroundColor: "#0077b3",
    },
  },
  footerText: {
    marginTop: 4,
    fontSize: "16px",
    color: theme.palette.text.secondary,
    textAlign: "center",
  },
  contactHeading: {
    fontWeight: "bold",
    marginBottom: 1,
    color: theme.palette.text.primary,
    textAlign: "center",
    letterSpacing: 1,
    fontSize: 24,
  },
};
